import * as React from 'react';
import * as queryString from 'query-string';
import HttpService from '../../../modules/core/services/HttpService';
import SnackbarService from '../../../modules/core/services/SnackbarService';
import { isAdmin } from '../../core/auth/identityAuth';
import Form from '../../shared/components/Form';
import {
  Button,
  Checkbox,
  createStyles,
  Divider,
  FormControlLabel,
  Paper,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core'
import Asset, { IAssetConfigField } from '../models/Asset';
import Subscription from '../models/Subscription';
import { isEqual } from "lodash";
import HttpCallConfig from '../../core/models/HttpCallConfig';
import SiteCoreService from '../../core/services/SiteCoreService';
import SiteCoreHelper from '../../core/helpers/SiteCoreHelper';
import SubscriptionConfig from '../components/SubscriptionConfig/SubscriptionConfig';
import { SubscriptionStatusIds } from "../../shared/constants";
import { getCommunityConfig, getMyMemberships } from "../../communities/api/communitiesApi";
import OrganizationCommunity from "../../organization/models/OrganizationCommunity";
import { OrganizationCommunityMembershipStatus } from "../../organization/models/OrganizationCommunityMembershipStatus";
import * as moment from 'moment'
import { dateIsLessThan24HoursAgo } from "../../shared/helpers/DateHelper";
import Alert from "../../shared/components/Alert";
import { getAsset } from "../../shared/services/AssetApi";
import { getSubscriptionsByAssetId } from "../../shared/services/SubscriptionsApi";
import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";
import { RouteComponentProps } from "react-router-dom";
import Loading from "../../shared/components/loading/Loading";
import ICommunityConfig from "../../communities/types/ICommunityConfig";

const siteCoreService = SiteCoreService.Instance;
const httpService = HttpService.Instance;
const snackbarService = SnackbarService.Instance;

const styles = (theme: Theme) => createStyles({
  main:
    {
      maxWidth: '40em',
      margin: '0 auto'
    }
});

interface IState {
  assetName: string;
  planIsValid: boolean,
  sitecoreAsset: ISitecoreAsset | undefined,
  isLoading: boolean,
  configFields: any[],
  configValues: any,
  requiredCommunity: ICommunityConfig | null,
  existingCommunityMembership: OrganizationCommunity | null,
  subscriptions: Subscription[],
  asset: Asset | undefined,
}

interface IProps extends WithStyles<typeof styles>, RouteComponentProps<any> {
  isSingleUserEntity: boolean;
}

class Subscribe extends React.Component<IProps, IState> {

  public formComponent: Form
  public queryObject: any

  constructor(props: any) {
    super(props);
    this.state = {
      assetName: '',
      planIsValid: true,
      sitecoreAsset: undefined,
      isLoading: true,
      configFields: [],
      configValues: {},
      requiredCommunity: null,
      existingCommunityMembership: null,
      subscriptions: [],
      asset: undefined,
    };
    this.queryObject = queryString.parse(window.location.search);
    this.getFormData = this.getFormData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.saveData = this.saveData.bind(this);
    this.getSubscriptionMessage = this.getSubscriptionMessage.bind(this);
  }

  public async componentDidMount() {
    await this.loadData();
  }

  public async saveData(data: any) {
    const postPromises: Array<Promise<any>> = [];
    if (data.termsAndConditonsIsChecked) {
      data.subscriptionsByEnvironment.forEach((environment: any) => {
        if (!environment.subscribed && environment.subscribe) {
          const result = {
            assetId: this.queryObject.assetId,
            planId: this.queryObject.planId,
            environmentId: environment.environmentId,
            consentGiven: data.termsAndConditonsIsChecked,
            termsAndConditionsVersion: SiteCoreHelper.getTermsAndConditionsVersion(this.state.sitecoreAsset),
            roles: environment.roles
              .filter((role: any) => role.subscribe)
              .map((role: any) => ({ id: role.id })),
            configValues: this.getFormattedConfigValues(),
          }
          const httpCallConfig = new HttpCallConfig;
          httpCallConfig.successMessage = "Subscription requested."
          httpCallConfig.successCallBack = () => {
            this.props.history.push({
              pathname: '/request-subscription-confirmation',
              state: {
                requiredCommunity: this.state.requiredCommunity
              }
            })
          }
          httpCallConfig.successCallBack = httpCallConfig.successCallBack.bind(this)
          postPromises.push(httpService.post(process.env.REACT_APP_API_URL + 'subscriptions', result, httpCallConfig))
        }
      });
    } else {
      snackbarService.showSnackbar('error', 'Terms & conditions not accepted')
    }
    return Promise.all(postPromises);
  }

  public getFormattedConfigValues = () => {
    return this.state.configFields.map((field: any) => {
      const value = this.state.configValues[field.field];
      if (field.type === 'checkbox') {
        return {
          field: field.field,
          value: field.options.filter((option: string) => value[option] === true).join(','),
        };
      }
      if (field.type === 'toggle') {
        return {
          field: field.field,
          value: value.toString(),
        };
      }
      return {
        field: field.field,
        value,
      };
    });
  };

  public mapConfigField(field: IAssetConfigField) {
    return { ...field, options: field.options ? field.options.split(';') : [] };
  }

  public reduceConfigValue(values: any, field: IAssetConfigField) {
    if (field.type === 'checkbox') {
      values[field.field] = {};
    } else if (field.type === 'toggle') {
      values[field.field] = false;
    } else {
      values[field.field] = '';
    }
    return values;
  }

  public onChangeConfigField = (event: any) => {
    const configValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    const configField = event.target.id || event.target.name;
    if (this.state.configValues[configField] instanceof Object) {
      this.setState({
        configValues: {
          ...this.state.configValues,
          [configField]: { ...this.state.configValues[configField], [event.target.name]: configValue }
        }
      });
    } else {
      this.setState({ configValues: { ...this.state.configValues, [configField]: configValue } });
    }
  }

  public getCancelUrl(): string {
    if (this.state.requiredCommunity) {
      return this.state.requiredCommunity.returnUrl;
    }
    return process.env.REACT_APP_PUBLIC_WEBSITE_URL + "/en/market/our-marketplace/marketplace";
  }

  public getSubscriptionMessage() {
    if (this.state.sitecoreAsset && this.state.sitecoreAsset.subscribeOverwrite) {
      return (
      <Typography className="padding-bottom-24">
        {this.state.sitecoreAsset.subscribeOverwrite}
      </Typography>)
    }

    return (
      <Typography className="padding-bottom-24">
        You are about to subscribe for {this.state.assetName}. Please be aware that this may involve
        a
        subscription based model with transaction fees and data fees. You can unsubscribe at any
        time by
        contacting <a href="mailto:support@nxtport.com">support@nxtport.com</a>. Want to know more
        about
        the difference between our live environment and our sandbox? <a
        href={process.env.REACT_APP_PUBLIC_WEBSITE_URL + "/market/sandbox"} target="_blank">Click
        here</a>
      </Typography>
    )
  }

  public async loadData() {
    const httpCallConfig = new HttpCallConfig;
    httpCallConfig.enforceErrorPage = true;

    const sitecoreAsset: ISitecoreAsset | undefined = await siteCoreService.getSiteCoreAsset(this.queryObject.assetId);

    let asset: Asset | undefined;
    let subscriptions: Subscription[] = [];

    if (isAdmin) {
      // only load these if user is admin. Otherwise, they will return 403 forbidden
      [asset, subscriptions] = await Promise.all([
        getAsset(this.queryObject.assetId, httpCallConfig),
        getSubscriptionsByAssetId(this.queryObject.assetId)
      ]);
    }
    let existingCommunityMembership = null;
    let requiredCommunity = null;
    if (asset && asset.community) {
      const [existingMemberships, communityConfig] = await Promise.all([
        getMyMemberships(),
        getCommunityConfig(asset.community.communityCode),
      ])
      requiredCommunity = communityConfig;
      const { communityCode } = asset.community;
      existingCommunityMembership = existingMemberships.find((membership: OrganizationCommunity) => membership.communityCode === communityCode);
    }

    const nxtportAssetName = asset ? asset.name : ''; // sonarcloud asked for this...
    this.setState({
      isLoading: false,
      asset,
      requiredCommunity,
      subscriptions,
      existingCommunityMembership: existingCommunityMembership || null,
      sitecoreAsset,
      assetName: sitecoreAsset ? sitecoreAsset.title : nxtportAssetName,
      planIsValid: asset ? !!asset.plans.find((plan: any) => plan.id === this.queryObject.planId) : false,
      configFields: asset ? asset.configFields.map(this.mapConfigField) : [],
      configValues: asset ? asset.configFields.reduce(this.reduceConfigValue, {}) : {}
    })
  }

  public async getFormData() {
    const { asset, subscriptions } = this.state;
    let subscriptionsByEnvironment = []
    if (asset) {
      const roles = asset.roles || [];

      subscriptionsByEnvironment = asset.environments.map((environment: any) => {
        const subscription = subscriptions.find(sub => sub.environment.id === environment.id
          && (sub.state.id === SubscriptionStatusIds.Requested
            || sub.state.id === SubscriptionStatusIds.Approved
            || sub.state.id === SubscriptionStatusIds.Active));

        return {
          subscribed: !!subscription,
          subscribe: !!subscription,
          environmentName: environment.name,
          environmentId: environment.id,
          roles: roles.map((role: any) => ({
            id: role.id,
            name: role.name,
            subscribe: false,
          })),
        };
      });
    }

    return {
      subscriptionsByEnvironment,
      termsAndConditonsIsChecked: false
    }
  }

  public renderSingleUserEntityNotAllowed() {
    return (
      <div className={this.props.classes.main}>
        <Typography variant="title">
          {this.state.assetName}
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          Subscription request
        </Typography>

        <Paper className="padding-24">
          {this.getSubscriptionMessage()}
          <Divider/>

          <div style={{ marginTop: '24px', marginBottom: '24px' }}>
            <Alert
              severity='error'
              title="Asset not available for single users"
            >
              <Typography color="inherit">
                You are logged in as a single user and can therefore not subscribe to this asset.
                <br/> Please contact <a href="mailto:support@nxtport.com">NxtPort support</a> if you have any questions.
              </Typography>

            </Alert>
          </div>
          
        </Paper>
      </div>
    );
  }

  public renderInsufficientPrivileges() {
    return (
      <div className={this.props.classes.main}>
        <Typography variant="title">
          {this.state.assetName}
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          Subscription request
        </Typography>

        <Paper style={{ padding: '24px', marginBottom: '24px' }}>
          {this.getSubscriptionMessage()}
          <Divider/>

          <div style={{ marginTop: '24px', marginBottom: '24px' }}>
            <Alert
              severity='error'
              title="You are not an admin of your entity"
            >
              <Typography color="inherit">
                You have insufficient privileges to subscribe to an asset. Please ask your organization admin to request
                a subscription for this asset.
              </Typography>
            </Alert>
          </div>
        </Paper>
        <Button
          onClick={() => window.location.assign(this.getCancelUrl())}
          variant="outlined"
          color="secondary"
        >
          Cancel
        </Button>
      </div>);
  }

  public renderCommunityMembershipRequired() {
    const { requiredCommunity } = this.state;

    if (!requiredCommunity) {
      // should never happen,  function is only called if this is truthy
      throw new Error('Could not show request membership screen.')
    }

    return (
      <div className={this.props.classes.main}>
        <Typography variant="title">
          {this.state.assetName}
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          Subscription request
        </Typography>

        <Paper style={{ padding: '24px', marginBottom: '24px' }}>
          {this.getSubscriptionMessage()}
          <Divider/>

          <div style={{ marginTop: '24px', marginBottom: '24px' }}>
            <Alert 
              severity='warning'
              title={`This asset is only available for members of the ${requiredCommunity.name} community.`}
            >
              <Typography color="inherit">
                You currently do not have an active membership.
                To continue, you need to request a membership to
                the {requiredCommunity.name} community and return to this page once your request has been
                approved.
              </Typography>
            </Alert>
          </div>
          <Button
            onClick={() => window.location.assign(`/request-community-membership?nxtCommunity=${requiredCommunity.code}`)}
            variant="contained"
            color="primary"
          >
            Request membership
          </Button>
        </Paper>
        <Button
          onClick={() => window.location.assign(this.getCancelUrl())}
          variant="outlined"
          color="secondary"
        >
          Cancel
        </Button>
      </div>);
  }


  public renderCommunityMembershipStatus() {
    const { requiredCommunity, existingCommunityMembership } = this.state;

    if (!existingCommunityMembership || !requiredCommunity) {
      // should never happen,  function is only called if these are truthy
      throw new Error('Could not show existing community membership status.')
    }

    const membershipIsPendingAndCreatedInLast24Hours = (membership: OrganizationCommunity) => {
      return membership.status === OrganizationCommunityMembershipStatus.Pending && dateIsLessThan24HoursAgo(moment(membership.createdOn));
    }

    return (
      <div className={this.props.classes.main}>
        <Typography variant="title">
          {this.state.assetName}
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          Subscription request
        </Typography>

        <Paper style={{ padding: '24px', marginBottom: '24px' }}>
          {this.getSubscriptionMessage()}
          <Divider/>

          <div style={{ marginTop: '24px', marginBottom: '24px' }}>
            <Alert
              severity='warning'
              title={`This asset is only available for members of the ${requiredCommunity.name} community.`}
            >
                <Typography color="inherit">
                  Your membership for this community is currently in state {existingCommunityMembership.status}.
                  Until your membership has been approved, you can not subscribe to this asset.
                  You will receive an email once your membership status has changed.
                </Typography>
                {!membershipIsPendingAndCreatedInLast24Hours(existingCommunityMembership)
                  &&
                  <Typography color="inherit">
                    If you need help, please <a href="mailto:support@nxtport.com">contact NxtPort support</a>.
                  </Typography>
                }
            </Alert>
          </div>
        </Paper>
        <Button
          className="margin-top-24"
          onClick={() => window.location.assign(this.getCancelUrl())}
          variant="outlined"
          color="secondary"
        >
          Cancel
        </Button>
      </div>);
  }


  public render() {
    const blockSingleUserSubscriber = this.props.isSingleUserEntity && this.state.asset && !this.state.asset.allowSingleUserEntitySubscriptions;

    if (this.state.isLoading) {
      return (
        <div className={this.props.classes.main}>
          <Loading/>
        </div>
      );
    }
    
    if (blockSingleUserSubscriber) {
      return this.renderSingleUserEntityNotAllowed();
    }

    if (!isAdmin) {
      return this.renderInsufficientPrivileges();
    }

    const userIsNotMemberOfRequiredCommunity = this.state.requiredCommunity && !this.state.existingCommunityMembership;
    if (userIsNotMemberOfRequiredCommunity) {
      return this.renderCommunityMembershipRequired();
    }

    const membershipExistsButIsNotYetActive = this.state.requiredCommunity && this.state.existingCommunityMembership && this.state.existingCommunityMembership.status !== OrganizationCommunityMembershipStatus.Active;
    if (membershipExistsButIsNotYetActive) {
      return this.renderCommunityMembershipStatus();
    }

    return (
      <div className={this.props.classes.main}>
        <Typography variant="title">
          {this.state.assetName}
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          Subscription request
        </Typography>

        <Form
          ref={(ref: Form) => this.formComponent = ref}
          history={this.props.history}
          saveFormPromise={this.saveData}
          getFormPromise={this.getFormData}
          refreshHandler={
            (callback?: () => void) => {
              this.forceUpdate(() => {
                if (callback) {
                  callback()
                }
              })
            }
          }
        >

          {!this.state.isLoading &&
            <div>
              {!this.state.planIsValid &&
                <Typography>
                  Given plan is not available for this subscription.
                </Typography>
              }
              {!this.state.sitecoreAsset &&
                <Typography>
                  We couldn't map your asset to the marketplace. Either the asset doesn't exist on the
                  marketplace
                  or it's temporary unavailable. Please contact <a href="mailto:support@nxtport.com">support</a>.
                </Typography>
              }
              {this.formComponent && this.formComponent.formShadowData && this.state.planIsValid && this.state.sitecoreAsset &&
                <div>
                  {this.getSubscriptionMessage()}

                  {this.state.requiredCommunity &&
                    <div style={{ marginBottom: '24px' }}>
                      <Alert 
                        severity='success'
                        title='Membership check succeeded'
                      >
                        <Typography color="inherit">
                          This asset is for {this.state.requiredCommunity.name} community members only. You are
                          an active member.
                        </Typography>
                      </Alert>
                    </div>
                  }

                  <Divider/>
                  <div className="padding-bottom-24"/>
                  <Typography variant="subheading">
                    Check the environment(s) you want to subscribe to
                  </Typography>
                  <Typography variant="caption">
                    This form can't be used to unsubscribe
                  </Typography>
                  {this.formComponent.formShadowData.subscriptionsByEnvironment.map((environmentSubscription: any) => {
                    return (
                      <div key={environmentSubscription.environmentId}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="subscribe"
                              disabled={environmentSubscription.subscribed}
                              onChange={(e: any) => {
                                this.formComponent.onChangeHandler(e, { itemRef: environmentSubscription })
                              }}
                              checked={environmentSubscription.subscribe}
                            />
                          }
                          label={environmentSubscription.environmentName}
                        />
                        {environmentSubscription.subscribe && !environmentSubscription.subscribed && environmentSubscription.roles.length ?
                          <React.Fragment>
                            <Typography variant="subheading">
                              Choose the role(s) for environment {environmentSubscription.environmentName}
                            </Typography>
                            {environmentSubscription.roles.map((role: any) => {
                              return (
                                <div key={role.id}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name="subscribe"
                                        onChange={(e: any) => {
                                          this.formComponent.onChangeHandler(e, { itemRef: role })
                                        }}
                                        checked={role.subscribe}
                                      />
                                    }
                                    label={role.name}
                                  />
                                </div>
                              );
                            })}
                            <Divider/>
                          </React.Fragment> : null}
                        {environmentSubscription.subscribe && !environmentSubscription.subscribed && environmentSubscription.environmentName === 'Live' ?
                          <SubscriptionConfig fields={this.state.configFields}
                                              values={this.state.configValues}
                                              onChange={this.onChangeConfigField}/> : null}
                      </div>
                    )
                  })}
                  {!isEqual(this.formComponent.formData, this.formComponent.formShadowData) &&
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="termsAndConditonsIsChecked"
                            checked={this.formComponent.formShadowData.termsAndConditonsIsChecked}
                            onChange={(e: any) => {
                              this.formComponent.onChangeHandler(e)
                            }}
                          />
                        }
                        label={
                          <span>I accept the <a href={SiteCoreHelper.getTermsAndConditionsUrl(this.state.sitecoreAsset) || ''}
                                                target="_blank">terms &amp; conditions</a></span>
                        }
                      />
                    </div>
                  }
                </div>
              }
            </div>}
        </Form>

        <div className='padding-bottom-24'/>
        <Button
          onClick={() => window.location.assign(this.getCancelUrl())}
          variant="outlined"
          color="secondary"
        >
          Cancel
        </Button>
      </div>
    )
  }
}

export default withStyles(styles)(Subscribe);



// WEBPACK FOOTER //
// ./src/modules/subscription/pages/Subscribe.tsx